export const initialValuesSignUp = {
  // Captcha token
  turnstileToken: '',

  // Identifiers
  email: '',
  confirmEmail: '',
  password: '',
  confirmPassword: '',

  //Personal
  civility: '',
  surname: '',
  firstName: '',
  dateOfBirth: '',

  //Address
  nameWay: '',
  numberApartment: '',
  nameComplement: '',
  nameAddress: '',
  locality: '',
  postCode: '',
  city: '',
  country: '',
  landLine: '',
  mobileNumber: '',

  //Newsletter
  newsAfibelMail: '',
  newsAfibelSms: '',
  newsPartnerAfibelMail: '',
};
